export default "__VITE_ASSET__CgWRwB$X__"